/**
 * Meridian artifacts — barrel.
 * See ./types.ts for the part schema and ./create-artifact-tool.ts for the tool.
 */

export {
  ARTIFACT_PART_TYPE,
  ARTIFACT_DATA_NAME,
  ARTIFACT_KINDS,
  MODEL_CREATABLE_ARTIFACT_KINDS,
  ARTIFACT_IMAGE_PATH_PREFIX,
  isRenderableArtifactImageSrc,
  artifactDataSchema,
  MERIDIAN_DATA_PART_SCHEMAS,
  MERIDIAN_ARTIFACT_MAX_CHARS_DEFAULT,
  resolveArtifactMaxChars,
  isArtifactUIPart,
  createArtifactEmitterRef,
} from './types';
export type {
  ArtifactData,
  ArtifactKind,
  ModelCreatableArtifactKind,
  ArtifactUIPart,
  EmitArtifact,
  ArtifactEmitterRef,
} from './types';

export {
  CREATE_ARTIFACT_TOOL_ID,
  createArtifactInputSchema,
  executeCreateArtifact,
  buildCreateArtifactTool,
  createArtifactToolDefinition,
  isCreateArtifactFailure,
} from './create-artifact-tool';
export type {
  CreateArtifactInput,
  CreateArtifactAck,
  CreateArtifactFailure,
  CreateArtifactResult,
} from './create-artifact-tool';
